<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="http://atexco.com.tr/"
        target="_blank"
      >Mert Dijital</b-link>
      <span class="d-none d-sm-inline-block">, Tüm hakları Saklıdır.</span>
    </span>
    <span class="float-md-right d-none d-md-block text-primary">Mert Dijital Makina San. ve Tic. Ltd. Şti.</span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
